import { Badge, Button, Group, Icon, Text } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';
import { useDeviceDelete } from '../../../../../../hooks/useDeviceDelete';
import useMediaQuery from '../../../../../../styles/useMediaQuery';
import type { DeviceData } from '../DeviceManagementPage';
import { DeviceItemLayout } from './DeviceItemLayout';
import { mapIcon } from './deviceUtils';

export function DeviceListItem({ device }: { device: DeviceData }) {
  const { t } = useTranslation();
  const { isMobile } = useMediaQuery();

  const { deleteDevice, isDeleting } = useDeviceDelete({
    deviceId: device.id ?? 0,
  });

  const handleRemove = () => {
    deleteDevice();
  };

  return (
    <DeviceItemLayout
      leading={
        <Icon icon={mapIcon(device.deviceType)} size={isMobile ? 'xl' : '2xl'} color="gray.5" />
      }
      content={
        <>
          <Text size={isMobile ? 'md' : 'lg'} fw={700} lh={1.3} c="gray.9">
            {device.deviceLabel}
          </Text>
          <Group spacing={4} mt={4} c="gray.6">
            <Text size={isMobile ? 'xs' : 'sm'} fw={400} lh={1.5}>
              {device.isCurrentDevice
                ? t('마이페이지_기기관리_기기상태_현재이용중')
                : t('마이페이지_기기관리_기기상태_마지막이용')}
            </Text>
            {device.isCurrentDevice ? null : (
              <Text size={isMobile ? 'xs' : 'sm'} fw={400} lh={1.5}>
                {device.lastUsedAt}
              </Text>
            )}
          </Group>
        </>
      }
      action={
        device.isCurrentDevice ? (
          <Badge variant="light" color="infgreen" size="lg" radius="xl">
            {t('마이페이지_기기관리_기기라벨_현재기기')}
          </Badge>
        ) : (
          <Button
            loading={isDeleting}
            variant="default"
            color="infgreen"
            size="xs"
            radius="md"
            onClick={handleRemove}
          >
            {t('마이페이지_기기관리_액션_삭제')}
          </Button>
        )
      }
    />
  );
}
